import type { ReactNode } from 'react';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

import { brand } from '../theme';

export interface SurfaceCardProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  'data-testid'?: string;
}

/** White card on the warm canvas: hairline border, generous radius, whisper of shadow. */
export default function SurfaceCard({
  children,
  sx,
  'data-testid': testId,
}: SurfaceCardProps) {
  return (
    <Box
      data-testid={testId}
      sx={{
        borderRadius: `${brand.cardRadius}px`,
        border: `1px solid ${brand.hairline}`,
        background: brand.surface,
        p: { xs: 2.5, sm: 3 },
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}

/** Card heading with an optional right-aligned meta slot. */
export function CardHeader({ title, meta }: { title: ReactNode; meta?: ReactNode }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1.5,
      }}
    >
      <Box sx={{ fontSize: 17, fontWeight: 700, letterSpacing: '-0.01em' }}>{title}</Box>
      {meta != null ? (
        <Box sx={{ fontSize: 12.5, fontWeight: 600, color: brand.faint }}>{meta}</Box>
      ) : null}
    </Box>
  );
}
